import React from "react";
import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Separator } from "../ui/separator";
import OrganizationCard from "./ProfileCards";
import { FormattedBody } from "../ui/formatted-body";
import ProfilePostsSection from "./ProfilePostsSection";

const sectionMotion = (reduced) =>
  reduced
    ? {}
    : {
        initial: { opacity: 0, y: 8 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, margin: "-40px" },
        transition: { duration: 0.25, ease: [0.25, 0.46, 0.45, 0.94] },
      };

/**
 * Read-only about + organization list + posts.
 * @param {Object} props
 * @param {Object} props.user
 * @param {number} props.userId - Logged-in viewer id
 * @param {Object} props.selfUser - Logged-in viewer user object
 * @param {boolean} [props.reduceMotion]
 * @returns {JSX.Element}
 */
const UserProfileInfo = ({ user, userId, selfUser, reduceMotion = false }) => {
  return (
    <div className="space-y-4">
      <motion.div {...sectionMotion(reduceMotion)}>
        <Card className="shadow-profile-sm">
          <CardHeader className="pb-2">
            <CardTitle className="text-lg text-text-primary">About</CardTitle>
            <Separator />
          </CardHeader>
          <CardContent>
            <FormattedBody as="p" className="text-text-secondary">
              {user?.bio || "No bio available."}
            </FormattedBody>
          </CardContent>
        </Card>
      </motion.div>

      <motion.div {...sectionMotion(reduceMotion)}>
        <Card className="shadow-profile-sm">
          <CardHeader className="pb-2">
            <CardTitle className="text-lg text-text-primary">Organizations</CardTitle>
          </CardHeader>
          <CardContent>
            {user?.affiliations && user.affiliations.length > 0 ? (
              <div className="space-y-2">
                {user.affiliations
                  .filter((aff) => aff.status === "active")
                  .map((affiliation) => (
                    <OrganizationCard
                      key={affiliation.id}
                      organization={affiliation.organization}
                    />
                  ))}
              </div>
            ) : (
              <p className="text-sm text-text-muted">No organizations found.</p>
            )}
          </CardContent>
        </Card>
      </motion.div>

      {/* <motion.div {...sectionMotion(reduceMotion)}>
        <Card className="shadow-profile-sm">
          <CardHeader className="pb-2">
            <CardTitle className="text-lg text-text-primary">Posts</CardTitle>
            <Separator />
          </CardHeader>
          <CardContent>
            <ProfilePostsSection
              viewerId={userId}
              viewerUser={selfUser}
              authorId={user?.id}
              isOrg={false}
            />
          </CardContent>
        </Card>
      </motion.div> */}
    </div>
  );
};

export default UserProfileInfo;
